<template>
  <v-dialog
    v-model="showUpgradeDowngradeTypeDialog"
    width="800"
  >
    
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        x-small
        v-bind="attrs"
        v-on="on"
        @click="loadUpgradeDowngradePlan"
        :disabled="!plan || (isUpgrade && !plan.upGrade) || (!isUpgrade && !plan.downGrade)"
      >
        <v-icon x-small :color="iconColor">{{isUpgrade?'fas fa-arrow-up':'fas fa-arrow-down'}}</v-icon>
      </v-btn>
    </template>
    
    <v-card
      elevation="2"
      outlined
    >
      <v-card-title class="text-h5 muted lighten-2" style="text-align: center">
        Classificação de Plano
      </v-card-title>

      <v-card-text>
        <br>
        <Title :title="titleUpgradeDowngrade"></Title>
        <v-simple-table >
          <template v-slot:default>
            <thead>
            <tr>
              <th class="text-center">
                <v-checkbox dense @change="selectDeselectAll" v-model="isSelectAll"></v-checkbox>
              </th>
              <th class="text-right">
                Classificação Plano
              </th>
              <th class="text-left">
                Plano Operadora
              </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="fp in filteredPlans">
              <td class="text-center col-1">
                <v-checkbox dense v-model="planIds" :value="fp.id"></v-checkbox>
              </td>
              <td class="text-right col-3">{{ fp.priority }}</td>
              <td class="text-left">{{ fp.description }}</td>
            </tr>
            </tbody>
          </template>
        </v-simple-table>
        
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          small
          @click="selectPlans"
        >
          Ok
        </v-btn>
        <v-btn
          small
          @click="showUpgradeDowngradeTypeDialog = false"
        >
          Cancelar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Title from "@/components/structure/title"

export default {
  components: {Title},
  props:{
    upgradeDowngrade: {
      type: []
    },
    isUpgrade: {
      type: Boolean
    },
    plansType: {
      type: []
    },
    plan: {
      type: Object
    },
  },
  data(){
    return {
      showUpgradeDowngradeTypeDialog: false,
      isSelectAll: false,
      planIds: [],
      filteredPlans:[]
    }
  },
  methods:{
    loadUpgradeDowngradePlan(){
      this.planIds = [];
      this.upgradeDowngrade.forEach(plan => {
          this.planIds.push(plan.id);
      });
      this.plansType.sort((a,b) => {
        if(a.priority < b.priority){
          return -1;
        }else if(a.priority > b.priority){
          return 1;
        } else {
          return 0;
        }
      });
      this.filteredPlans = this.plansType.filter((item) => {
        let retorno = false;
        if(this.isUpgrade){
          retorno = item && this.plan && item.priority < this.plan.priority;
        } else {
          retorno = item && this.plan && item.priority > this.plan.priority;
        }
        return retorno;
      });
    },
    selectDeselectAll(){
      this.planIds = [];

      if (this.isSelectAll) {
        this.plansType.forEach((plan, index) => {
          this.planIds.push(plan.id);
        });
      }
      
      
    },
    selectPlans(){
      this.upgradeDowngrade.splice(0);
      this.plansType.forEach((plan, index) => {
        if(this.planIds.includes(plan.id)) {
          this.upgradeDowngrade.push(plan);
        }
      });
      this.showUpgradeDowngradeTypeDialog = false;
    }
  },
  computed:{
    titleUpgradeDowngrade(){
      return this.isUpgrade?'Upgrade':'Downgrade';
    },
    iconColor(){
      if(this.upgradeDowngrade.length>0){
        return this.isUpgrade?'green':'red';
      }
      return '';
    }
  },
  name: "dlg_upgrade_downgrade_plan"
}
</script>

<style scoped>

</style>
